import { HTMLStyledProps, Stack } from "@zenchef/styled-system/jsx";
import { aromaEmptyState } from "@zenchef/styled-system/recipes";
import Illustrations from "../Art/Illustrations";
import Art from "../Art/Art";
import { ReactNode } from "react";

export const emptyStateSizes = ["small", "medium", "large"] as const;
export type EmptyStateSize = (typeof emptyStateSizes)[number];

export const emptyStateFunctions = [
  "Guide",
  "TaskCompleted",
  "Success",
  "Error",
  "Loading",
  "Information",
] as const;
export type EmptyStateFunction = (typeof emptyStateFunctions)[number];

const functionArtMap = {
  Guide: "Bread",
  TaskCompleted: "Stars",
  Success: "Note",
  Error: "Plate",
  Loading: "Table",
  Information: "Coffee",
} as const satisfies Record<EmptyStateFunction, keyof typeof Illustrations>;

export type EmptyStateProps = HTMLStyledProps<"div"> & {
  functionName: EmptyStateFunction;
  size: EmptyStateSize;
  heading: string;
  motivation?: string;
  actions?: ReactNode;
};

const EmptyState = ({
  functionName,
  size,
  heading,
  motivation,
  actions,
}: EmptyStateProps) => {
  const classes = aromaEmptyState({ function: functionName, size });
  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Art
          name={functionArtMap[functionName]}
          className={classes.art}
          layout="vertical"
        />
        <Stack gap="gap.1" align="center">
          <strong className={classes.heading}>{heading}</strong>
          {motivation && <p className={classes.motivation}>{motivation}</p>}
        </Stack>
      </div>
      {actions && (
        <Stack direction="row" gap="gap.2">
          {actions}
        </Stack>
      )}
    </div>
  );
};

export default EmptyState;
